import React from 'react';

export default function PercentageMask({
  isLandscape = false,
  selectCategory,
  primaryColor,
}) {
  if (!selectCategory || !selectCategory.ratio) {
    return <div />;
  }
  const ratios = selectCategory.ratio.split(',').map(r => parseFloat(r.trim()));

  switch (selectCategory.value) {
    case 'face1_3Rule':
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          {ratios.map((ratio, index) => {
            const top = ratios.slice(0, index).reduce((a, b) => a + b, 0);
            return (
              <div
                key={index}
                style={{
                  position: 'absolute',
                  top: `${top}%`,
                  height: `${ratio}%`,
                  width: '100%',
                }}
              >
                <span
                  style={{
                    position: 'absolute',
                    right: '-40px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: primaryColor,
                    color: 'white',
                    borderRadius: '6px',
                    fontSize: '8px',
                    padding: '2px 6px',
                  }}
                >
                  {ratio}%
                </span>
              </div>
            );
          })}
        </div>
      );
    case 'face1_5Rule':
      let accumulatedLeft = 0;
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          {ratios.map((ratio, index) => {
            const style = {
              position: 'absolute',
              left: `${accumulatedLeft}%`,
              width: `${ratio}%`,
              height: '100%',
            };
            const labelStyle = {
              position: 'absolute',
              bottom: '-20px',
              left: '50%',
              transform: 'translateX(-50%)',
              background: primaryColor,
              color: 'white',
              borderRadius: '6px',
              fontSize: '6px',
              padding: '2px 6px',
            };

            accumulatedLeft += ratio;

            return (
              <div key={index} style={style}>
                <span style={labelStyle}>{ratio}%</span>
              </div>
            );
          })}
        </div>
      );
    case 'faceAspectRatio':
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-12px',
              left: '45%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 8px',
              }}
            >
              1
            </span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 6px',
              }}
            >
              1.46
            </span>
          </div>
        </div>
      );
    case 'eyeHeightToEyebrowDistance':
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '30%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 2px',
              }}
            >
              1.618
            </span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '51%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 6px',
              }}
            >
              1
            </span>
          </div>
        </div>
      );
    case 'noseAspectRatio':
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '110%',
              left: '45%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 8px',
              }}
            >
              1
            </span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 6px',
              }}
            >
              1.46
            </span>
          </div>
        </div>
      );

    case 'noseWidthToMouthWidth':
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '-8%',
              left: '45%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 8px',
              }}
            >
              1
            </span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '108%',
              left: '45%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 6px',
              }}
            >
              1.618
            </span>
          </div>
        </div>
      );
    case 'noseToLipToChin':
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '30%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 6px',
              }}
            >
              1
            </span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '70%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 2px',
              }}
            >
              1.618
            </span>
          </div>
        </div>
      );
    case 'upperLipToLowerLip':
      return (
        <div
          style={{
            position: 'absolute',
            ...(isLandscape
              ? selectCategory.image_landscape_ratio_position
              : selectCategory.image_portrait_ratio_position),
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: '45%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 6px',
              }}
            >
              1
            </span>
          </div>
          <div
            style={{
              position: 'absolute',
              top: '60%',
              left: '103%',
              width: '100%',
            }}
          >
            <span
              style={{
                position: 'absolute',
                transform: 'translateY(-50%)',
                background: primaryColor,
                color: 'white',
                borderRadius: '6px',
                fontSize: '8px',
                padding: '2px 2px',
              }}
            >
              1.618
            </span>
          </div>
        </div>
      );
    default:
      return <div />;
  }
}
